(() => {

    function sortProducts() {

        const grid = document.querySelector(".product-grid");
        if (!grid) return;

        const cards = [...grid.querySelectorAll(".product-grid__item")];

        cards.sort((a, b) => {

            const av = Number(a.querySelector("product-card")?.dataset.productAvailable || 0);
            const bv = Number(b.querySelector("product-card")?.dataset.productAvailable || 0);

            return bv - av;

        });

        grid.replaceChildren(...cards);

        console.log("Sorted", cards.length);

    }

    document.addEventListener("DOMContentLoaded", () => {

        setTimeout(sortProducts,500);

    });

    document.addEventListener("scroll", () => {

        clearTimeout(window.__bmTimer);

        window.__bmTimer = setTimeout(sortProducts,300);

    });

})();